"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlByParameters = void 0;
const objectUtils_1 = __importDefault(require("./objectUtils"));
/**
 * 依照傳入data轉換為url
 * @param parameters {curNum:1,size:5}
 * @returns curNum=1&size=5
 */
const getUrlByParameters = (parameters) => {
    const array = [];
    for (const [key, value] of Object.entries(parameters)) {
        if (objectUtils_1.default.isExist(value))
            array.push(`${key}=${value}`);
    }
    return array.join('&');
};
exports.getUrlByParameters = getUrlByParameters;
